<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.qualityItem.new')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/qualityItem"><span>{{$t('tlt.qualityItem.list')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/qualityItem/edit"><span>{{$t('tlt.qualityItem.new')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('qualityItem')"><i class="fa fa-fw fa-lg fa-minus-circle"></i><span class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <!-- <button class="btn btn-primary" type="button" v-on:click="validateForm"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>Save</span></button> -->
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('qualityItem')"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>
        
       <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.qualityItemCode')}}:</label>
                                <input  v-validate="'required'" name="itemCode"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('itemCode') }"
                                    v-model="itemCode" type="text">
                                <span v-show="errors.has('itemCode')" class="lbl-obg">
                                    {{ errors.first('itemCode') }}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.qualityItemName')}}:</label>
                                <input   v-validate="'required'" name="itemName"
                                    :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('itemName') }"
                                    v-model="itemName" type="text">
                                <span v-show="errors.has('itemName')" class="lbl-obg">
                                    {{ errors.first('itemName') }}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.qualityItemCraftType')}}:</label>
                                     <select class="form-control" type="text" v-model="craftType">
                                          <option value>{{ $t("lbl.basic.select.one") }}</option>
                                          <option value="p">{{$t("lbl.qualityItem.pelletizing")}}</option>
                                          <option value="s">{{$t("lbl.qualityItem.smelt")}}</option>
                                       
                                  </select>
                                <span v-show="errors.has('craftType')" class="lbl-obg">
                                    {{ errors.first('craftType') }}
                                </span>
                            </div>
                              <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.qualityItemCheckType')}}:</label>
                                     <select class="form-control" type="text" v-model="checkType">
                                         <option value>{{ $t("lbl.basic.select.one") }}</option>
                                         <option value="material">{{$t("lbl.qualityItem.material")}}</option>
                                        <option value="process">{{$t("lbl.qualityItem.process")}}</option>
                                        <option value="production">{{$t("lbl.qualityItem.production")}}</option>
                                       
                                  </select>
                                <span v-show="errors.has('checkType')" class="lbl-obg">
                                    {{ errors.first('checkType') }}
                                </span>
                            </div>
                    
                        </div>                     
                    </div>
                </div>
                
            </form>
             
        </section>
    </div>
 </template>
<style>
.CodeMirror {
  border: 1px solid #eee;
  /* todo change to responsible */
  height: 260px; 
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {   fields } from "@/model/prd/qualityMgt/qualityItemConfig/QualityItem";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "qualityItem/getField",
  mutationType: "qualityItem/updateField"
});

export default {
  name: "qualityItemEdit",
  data() {
    return {
      
    };
  },

  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
   
   ...mapFields(fields),
    ...mapState({
      rows: state => state.qualityItem.rows,

      entity: state => state.qualityItem.entity,  
     
    })
  },
  methods: {
    ...mapActions("base", [
      "MMFbackToList",
      "MMFSave"
     
    ]),
   
    
   
  },
  
 
};
</script>
